import { Spin } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Screenback from '../../../../components/screenBack/screenBack';
import { GetGapDetailsList } from '../../action/util_action';

import OrderBookingTable from '../orders/OrderBookingTable';
import { useLocation } from 'react-router-dom';
import { decodeToken } from '../../../../utils/settings';
import { Container } from '@mui/material';

export const currencyNumber = (amt) => {
  return amt.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const GoldenAgePlanListing = () => {
  const location = useLocation();
  const tdsData = location.state?.data || null;

  const [gapData, setGapData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [decodedData, setDecodedData] = useState({});
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setDecodedData(decoded);
  };
  useEffect(() => {
    getTokenData();
  }, []);
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  useEffect(() => {
    GetDataGapDetailsList();
  }, [pageNumber, decodedData]);

  // ----------- Checking Inventory And Transaction -----------
  const GetDataGapDetailsList = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append('f', 'id$gte$0');
    params.append('o', 'id$desc');
    params.append(
      'f',
      `company_id$eq$${decodedData?.default_company_info?.company_id}`,
    );
    params.append('page', pageNumber);
    params.append('page_size', 10);

    let { error, data, message } = await GetGapDetailsList(params);
    setLoading(false);

    if (!error) {
      setGapData(data);
    }
  };

  const periodOfGap = (start, end) => {
    return start === end
      ? `${moment(start).format('MMM YYYY')}`
      : moment(start).month() === moment(end).month() &&
        moment(start).year() === moment(end).year()
      ? `${moment(start).format('MMM YYYY')}`
      : `${moment(start).format('MMM YYYY')}-${moment(end).format('MMM YYYY')}`;
  };
  const tableData = {
    rows: ['Period', 'Amount', 'Amount Current FYI'],
    tableData: gapData.map((item) => [
      `${
        item?.start && item?.end ? periodOfGap(item.start, item.end) : '🚫🚫🚫'
      }`,

      `${currencyNumber(Number(item.amount))}`,
      `${currencyNumber(Number(item.amount_without_tds))}`,
      // `${item?.is_active ? 'Unlocked' : 'Locked'}`,U+1F6AB,0xF0 0x9F 0x94 0x92,0xF0 0x9F 0x9A 0xAB
    ]),
    onRowClick: (index) => {},
  };

  const pageIncrementHandler = () => {
    if (gapData.length === 10) {
      setPageNumber((prev) => prev + 1);
    }
  };

  const pageDecrementHandler = () => {
    if (pageNumber > 1) {
      setPageNumber((prev) => prev - 1);
    }
  };

  const totalAmount = gapData
    .reduce((acc, item) => (acc += item.amount), 0)
    .toFixed(2);
  const totalAmountWithoutTds = gapData
    .reduce((acc, item) => (acc += item.amount_without_tds), 0)
    .toFixed(2);

  return (
      <div className='pageContentContainer'>
        <div style={{ width: '100%' }}>
          <Screenback />
        </div>

        <h1>GAP DETAILS</h1>

        <div style={{ width: '90%' }}>
          {!loading && (
            <div className={'paginationContainer'}>
              <div
                className={'nextBtn'}
                style={{ borderRadius: '5px' }}
                onClick={() => {
                  pageDecrementHandler();
                }}
              >
                Prev
              </div>
              <div
                className={'pageNumber'}
                style={{ margin: '0px 7px' }}
              >
                {pageNumber}
              </div>
              <div
                className={'nextBtn'}
                style={{ borderRadius: '5px' }}
                onClick={() => {
                  pageIncrementHandler();
                }}
              >
                Next
              </div>
            </div>
          )}
          <Spin spinning={loading}>
            <OrderBookingTable data={tableData} />
            <div
              className='ledger_table-row'
              style={{ backgroundColor: 'white' }}
            >
              <h5 className='ledger_table-title'>Total GAP</h5>
              <h5 className='ledger_table-title'>₹ {totalAmount}</h5>
              <h5 className='ledger_table-title'>₹ {totalAmountWithoutTds}*</h5>
            </div>
            <div
              className='ledger_table-row'
              style={{ backgroundColor: 'white' }}
            >
              <h5 className='ledger_table-title'>
                TDS under Section 194R of IT act @10%
              </h5>
              <h5
                className='ledger_table-title'
                style={{ color: 'red' }}
              >
                ₹ -{tdsData?.tds_value}
              </h5>
              <h5
                className='ledger_table-title'
                style={{ color: 'red' }}
              >
                -
              </h5>
            </div>
            <div
              className='ledger_table-row'
              style={{ backgroundColor: 'white' }}
            >
              <h5 className='ledger_table-title'>Net GAP Amount Accumulated</h5>
              <h5 className='ledger_table-title'>
                ₹{' '}
                {(Number(totalAmount) - Number(tdsData?.tds_value)).toFixed(2)}
              </h5>
              <h5 className='ledger_table-title'>₹ {totalAmountWithoutTds}*</h5>
            </div>
            <p
              style={{
                color: 'red',
                marginTop: '10px',
              }}
            >
              *Subject to TDS under Section 194R of IT act
            </p>
          </Spin>
        </div>
      </div>
  );
};

export default GoldenAgePlanListing;
